














































































































import { Component, Vue } from "vue-property-decorator";
import OkModal from "@/components/OkModal.vue";
import TicketComponent from "@/components/TicketComponent.vue";
import ProfileComponent from "@/components/ProfileComponent.vue";
import SalonService from "@/services/SalonService";
import FincodeCustomerService from "@/services/FincodeCustomerService";
import PurchasedTicketService from "@/services/PurchasedTicketService";
import SystemConst from "@/config/const";

@Component({
  name: "TicketBuyCheckApp",
  components: {
    OkModal,
    TicketComponent,
    ProfileComponent,
  },
})
export default class TicketBuyCheckApp extends Vue {
  salonId = "";
  ticketId = "";
  stripeCustomerId = "";
  salonIdSystem = "";
  maskedCardNumber = "";
  salon: any = {};
  ticket: any = {};
  profile: any = {};
  isProcessing = false;
  errorTitle = "";
  errorMessage = "";
  maskedCard = "";
  isSecretSale = false;
  parentCouponId = "";
  SystemConst = SystemConst;
  reviewStatus = "0";

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get refs(): any {
    return this.$refs;
  }

  get lastUsedCardText(): string {
    return this.maskedCard || "";
    // return `**** **** **** ${this.card.last4}`;
  }

  async buy() {
    this.isProcessing = true;
    const data = this.isSecretSale
      ? {
          ticket_id: this.ticket.id,
          token: this.$route.params.secret_sale_token,
          coupon_id: this.parentCouponId,
          salon_id: this.salonId
        }
      : {
          ticket_id: this.ticket.id,
          coupon_id: this.parentCouponId,
          salon_id: this.salonId
        };
    await PurchasedTicketService.createPurchasedTicket(data)
      // TODO
      // .then((response :any) => {
      //   window.location = response.data.item.url;
      .then(() => {
        this.$router.push({
          name: "TicketBuyDone",
          params: {
            salon_id: this.salonId,
            ticket_id: this.ticketId,
          },
        });
      })
      .catch((err: any) => {
        this.errorTitle = "システムエラー";
        this.errorMessage = "後でもう一度やり直してください";
        this.refs.errorOKModal.open();
      });
    this.isProcessing = false;
  }

  public async created() {
    if (this.$route.name == "SecretServiceBuyCheck") {
      this.isSecretSale = true;
    }
    this.salonId = this.$route.params.salon_id || this.$route.params.secret_sale_token;
    this.ticketId = this.$route.params.ticket_id;
    this.parentCouponId = this.$route.query.coupon_id
      ? String(this.$route.query.coupon_id)
      : "";

    const {
      data: { ticket, salon, review_status },
    } = await SalonService.getSalonAndTicket(this.salonId, this.ticketId, {
      view_done: false
    }).catch(() => {
      return { data: { ticket: null, salon: null, review_status: null } };
    });
    this.reviewStatus = review_status || "0";
    const {
      data: { masked_card },
    } = await FincodeCustomerService.getLastCardUsed().catch(() => {
      return { data: { masked_card: null } };
    });

    if (!salon || !ticket || !masked_card) {
      this.$router.push({ name: "NotFound" });
    }

    this.profile = this.$store.state.auth.user;
    this.salon = salon;
    this.salonId = salon.salon_id;
    this.ticket = ticket;
    this.maskedCard = masked_card;
    this.setTitle();
    const image_url = this.salon.image_logo_url;
    this.$store.dispatch("actionSetHeaderUrl", image_url);
    this.$store.dispatch("actionSetSalonName", salon.salon_name);
    this.$store.dispatch("actionSetSalonId", this.salon.salon_id);
  }

  setTitle() {
    document.title =
      "チケット購入 | " +
      this.salon.salon_name +
      " | favsalon(ファブサロン) | 再来率を向上させるサロンに特化したネットショップサービス";
    const descriptonMeta = document.querySelector("meta[name='description']");
    if (descriptonMeta) {
      descriptonMeta.setAttribute(
        "content",
        "チケット購入 | " +
          this.salon.salon_name +
          " | favsalonならサロンに特化したネットショップを簡単に作ることができます。シークレットサービスを作ってお客様の再来率を向上させることが可能です。"
      );
    }
    const robotsMeta = document.querySelector("meta[name='robots']");
    if (robotsMeta) {
      robotsMeta.setAttribute("content", "noindex");
    }
  }
}
